import React, {useState} from 'react';
import DownChevron from '@assets/svg/down_chevron_gray.svg';

const Select = (props) => {
  const {label, placeholder, options = [], containerClass, onChange} = props;

  const [showOptions, setShowOptions] = useState(false);
  const [selected, setSelected] = useState('');

  const optionsArray = () => {
    return options.map(option => {
      return <div
        key={option.name}
        className="hover:bg-primary hover:text-white py-0.5 px-3 flex flex-row items-center cursor-pointer "
        onClick={() => {
          setShowOptions(false)
          setSelected(option);
          onChange(option.id)
        }}
      >
        {option.name}
      </div>
    })
  }

  const onClickOutsideListener = () => {
    setShowOptions(false);
    document.removeEventListener("click", onClickOutsideListener);
  }

  const addOnClickOutsideListener = () => {
    document.addEventListener("click", onClickOutsideListener);
  }

  return (
    <div className={`w-full relative cursor-pointer ${containerClass}`} onBlur={() => addOnClickOutsideListener()}>
      {!!label && (<div className={'text-center w-full'}>{label}</div>)}
      <a
        className={`
                    ${showOptions ? 'border-primary' : ''}
                    ${!selected?.name ? 'italic text-slate-400 text-sm text-gray-400' : ''}
                    border border-gray-300 w-full focus:outline-none mr-2 bg-white
                    items-center flex flex-row rounded text-xl w-full h-12 px-3 py-2 rounded-md shadow-sm text-sm`
        }
        onClick={() => setShowOptions(!showOptions)}
      >
        {selected?.name ? selected.name : placeholder}
        <img src={DownChevron} className="px-3 absolute right-1"/>
      </a>
      <div
        className={`${!showOptions ? 'hidden' : ''} border-1 overflow-y-auto overflow-hidden w-full absolute z-50 bg-white max-h-80 mt-0.5`}>
        {optionsArray()}
      </div>
    </div>
  )
}

export default Select;

